import BossModel from "@/models/BossModel";
import Dossier from '@/models/Dossier/Dossier';
import HotelRequest from "@/models/WebsiteOffer/HotelRequest";
import OpenRequest from "@/models/WebsiteOffer/OpenRequest";
import PackageRequest from "@/models/WebsiteOffer/PackageRequest";
import TourRequest from "@/models/WebsiteOffer/TourRequest";
import ProductRequest from "@/models/WebsiteOffer/ProductRequest";
import PlatinumOfferRequest from "@/models/PlatinumOfferRequest/PlatinumOfferRequest";

export default class Lead extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'lead';

    /**
     *
     * @type {string}
     */
    static entity = 'leads';

    static fields() {
		return {
			id: this.attr(null),
			dossier_id: this.attr(null),
			leadable_type: this.attr(null),
			leadable_id: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            dossier: this.belongsTo(Dossier, 'dossier_id'),
            open_request: this.belongsTo(OpenRequest, 'leadable_id'),
            hotel_request: this.belongsTo(HotelRequest, 'leadable_id'),
            package_request: this.belongsTo(PackageRequest, 'leadable_id'),
            tour_request: this.belongsTo(TourRequest, 'leadable_id'),
            product_request: this.belongsTo(ProductRequest, 'leadable_id'),
            platinum_offer_request: this.belongsTo(PlatinumOfferRequest, 'leadable_id'),
		}
	}

    /**
     *
     * @returns {boolean|*}
     */
    Dossier() {
        return this.getRelated('dossier');
    }

    /**
     *
     * @returns {boolean|*}
     */
    HotelRequest() {
        if (this.leadable_type === 'hotel_request') {
            return this.getRelated('hotel_request');
        }

        return false;
    }

    /**
     *
     * @returns {boolean|*}
     */
    OpenRequest() {
        if (this.leadable_type === 'open_request') {
            return this.getRelated('open_request');
        }

        return false;
    }

    /**
     *
     * @returns {boolean|*}
     */
    PackageRequest() {
        if (this.leadable_type === 'package_request') {
            return this.getRelated('package_request');
        }

        return false;
    }

    /**
     *
     * @returns {boolean|*}
     */
    TourRequest() {
        if (this.leadable_type === 'tour_request') {
            return this.getRelated('tour_request');
        }

        return false;
    }

    /**
     *
     * @returns {boolean|*}
     */
    ProductRequest() {
        if (this.leadable_type === 'product_request') {
            return this.getRelated('product_request');
        }

        return false;
    }
}
